<!-- login.component.html -->
<div class="container-fluid min-vh-100 position-relative p-0 overflow-hidden login-container">
  <!-- Full Page Spinner Overlay - Only visible on small screens -->
  <div *ngIf="formSubmitLoader" class="spinner-overlay d-lg-none">
    <div class="spinner-wrapper">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  
  <!-- Side Images -->
  <img src="../assets/images/Group1.png" alt="" class="side-images d-none d-sm-block position-absolute top-0 start-0">
  <img src="../assets/images/Group2.png" alt="" class="side-images d-none d-sm-block position-absolute bottom-0 end-0">

  <!-- Desktop View  -->
  <div class="row g-0 min-vh-100 d-none d-lg-flex fixed-col">
    <!-- Left Column -->
    <div class="col-12 col-md-6 col-lg-6 bg-white p-5 fixed-col d-flex align-items-center justify-content-center" style="margin-bottom: 5px !important;">
      <div class="gap-3 d-flex flex-column">
        <div class="login-left-container logo-tagline" >
          <div class="logo-div"><img src="assets/images/PeriscopeLogo.png" alt="Logo" class="img-fluid vb-logo z-3"></div>
          <!-- <div class="tagline bg-dark">
            <p>
              <span class="color1">Seamless</span>
              <span class="color2">Welcomes</span>
            </p>
            <p>
              <span class="color2">Connected</span>
              <span class="color1">Experiences</span>
            </p>
          </div> -->
          </div>
        <div class="login-left-container"><img src="assets/images/Periscope-Graphic.png" alt="Visual" class="img-fluid visual-img"></div>

        <div class="login-left-container">
          <div class="d-flex flex-column powered-by-lg">
            <small class="text-center text-black mb-1">Powered by</small>
            <img src="assets/images/dnvLogo.png" alt="DNV Logo" class="img-fluid dnv-img">
          </div>           
        </div>
      </div>
    </div>

    <!-- Right Column -->
    <div class="col-12 col-md-6 col-lg-6 d-flex align-items-center justify-content-center form-col">
      <div class="w-100 px-3 px-md-4 px-lg-5" style="max-width: 500px;">
        <div class="card border-0 shadow-lg rounded-4 login-card">
          <div class="card-body p-3 p-md-4 p-lg-5">
            <h2 class="mb-1 fw-bolder fs-10">Login</h2>
            <p class="text-muted mb-4">Enter your details to get access to account</p>

            <form [formGroup]="loginForm" (ngSubmit)="login()" class="authentication-form">
              <div class="mb-4">
                <div class="input-group"
                  [ngClass]="{'is-invalid': (loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors}">
                  <span class="input-group-text border-end-0"><img src="assets/icons/email.png" /></span>
                  <input type="email" class="form-control border-start-0" placeholder="Email address"
                    formControlName="email"
                    [ngClass]="{'is-invalid': (loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors}">
                </div>
                <div class="invalid-feedback"
                  *ngIf="(loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors">
                  <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
                  <span *ngIf="loginForm.get('email')?.errors?.['pattern']">Please enter a valid email</span>
                </div>
              </div>

              <div class="mb-3">
                <div class="input-group"
                  [ngClass]="{'is-invalid': (loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors}">
                  <span class="input-group-text border-end-0"><img src="assets/icons/password.png" /></span>
                  <input [type]="showPassword ? 'text' : 'password'" class="form-control border-start-0 border-end-0"
                    placeholder="Password" formControlName="password"
                    [ngClass]="{'is-invalid': (loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors}">
                  <span class="input-group-text border-start-0 cursor-pointer" (click)="showPassword = !showPassword">
                    <i class="fa" [ngClass]="{'fa-eye-slash': showPassword, 'fa-eye': !showPassword}"></i>
                  </span>
                </div>
                <div class="invalid-feedback"
                  *ngIf="(loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors">
                  <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</span>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <a class="text-link fw-bolder small mb-3" routerLink="/forgot-password">Forgot password?</a>
              </div>              

              <button class="btn btn-bg fw-bolder w-100 py-2 fs-5 login-button rounded button-animations text-white" type="submit"
                [disabled]="formSubmitLoader">
                Login
                <i *ngIf="formSubmitLoader" class="spinner-border spinner-border-sm ms-2"></i>
              </button>

              <div class="text-center mt-5">
                <p class="mb-1">Don't have an account? <a class="text-link fw-bolder" routerLink="/register" style="margin-left: 4px;">Register
                    Now</a></p>
              </div>
            </form>

            <div class="footer-links text-center mt-4">
                    <!-- <a href="#">Terms of service</a>
          <span class="mx-2">·</span> -->
                    <a href="#" data-bs-toggle="modal" data-bs-target="#privacyModal"
                        (click)="openPrivacyModal()">Privacy policy</a>
                    <!-- <span class="mx-2">·</span>
          <a href="#">Support</a> -->
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile View - Updated to match the image -->
  <div class="row g-0 min-vh-100 d-flex d-lg-none mobile-view">
    <img src="assets/images/honeycomb-pattern.svg" alt="Honeycomb Background" class="honeycomb-bg position-absolute top-0 start-0">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center">
      <!-- Back Button -->
      <div class="position-absolute top-0 start-0 m-3">
        <a routerLink="/splash">
          <img src="assets/images/arrow-back.svg" alt="back" >
        </a>
      </div>
      
      <div class="mobile-login-container pb-2">
        <!-- Logo -->
        <div class="text-center mb-2">
          <img src="assets/images/PeriscopeLogo.png" alt="Visitor Bridge Logo" class="img-fluid mobile-logo">
        </div>
        
        <!-- GIF -->
        <div class="d-flex justify-content-center align-items-center">
          <img src="assets/images/Periscope-Graphic.png" alt="Visual" class="login-illustration img-fluid">
        </div>

        <!-- Login Form -->
        <form [formGroup]="loginForm" (ngSubmit)="login()" class="authentication-form">
          <!-- Email Input -->
          <div class="mb-3">
            <div class="mobile-input-group"
              [ngClass]="{'is-invalid': (loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors}">
              <span class="input-icon">
                <img src="assets/icons/email.png" />
              </span>
              <input type="email" class="form-control" placeholder="Email address"
                formControlName="email"
                [ngClass]="{'is-invalid': (loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors}">
            </div>
            <div class="invalid-feedback"
              *ngIf="(loginForm.get('email')?.touched || formSubmitted) && loginForm.get('email')?.errors">
              <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
              <span *ngIf="loginForm.get('email')?.errors?.['pattern']">Please enter a valid email</span>
            </div>
          </div>
  
          <!-- Password Input -->
          <div class="mb-3">
            <div class="mobile-input-group"
              [ngClass]="{'is-invalid': (loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors}">
              <span class="input-icon">
                <img src="assets/icons/password.png" />
              </span>
              <input [type]="showPassword ? 'text' : 'password'" class="form-control"
                placeholder="Password" formControlName="password"
                [ngClass]="{'is-invalid': (loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors}">
              <span class="password-toggle" (click)="showPassword = !showPassword">
                <i class="fa" [ngClass]="{'fa-eye-slash': showPassword, 'fa-eye': !showPassword}"></i>
              </span>
            </div>
            <div class="invalid-feedback"
              *ngIf="(loginForm.get('password')?.touched || formSubmitted) && loginForm.get('password')?.errors">
              <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</span>
            </div>
          </div>
  
          <!-- Login Button -->
          <button class="btn btn-primary w-100 py-2 mobile-login-button button-animations text-white" type="submit">
            Login
          </button>
  
          <!-- Forgot Password -->
          <div class="text-center mt-4">
            <a class="forgot-password mobile-register" routerLink="/forgot-password">Forgot password?</a>
          </div>
  
          <!-- Or Divider -->
          <div class="or-container text-center">
            <span class="or-divider">Or</span>
          </div>
          
  
          <!-- Register -->
          <div class="text-center mb-4">
            <p class="mb-2">Don't have an account? <a class="mobile-register" routerLink="/register">Register</a></p>
          </div>
        </form>
        
  
        <!-- Powered By -->
        <div class="text-center mt-3 powered-by">
          <small>Powered By</small>
          <img src="assets/images/dnvLogo.png" alt="DNV Group Logo" class="img-fluid dnv-mobile-logo">
        </div>
  
        <!-- Footer Links -->
        <div class="footer-links text-center mt-4">
          <!-- <a href="#">Terms of service</a>
          <span class="mx-2">·</span> -->
          <a href="#" data-bs-toggle="modal" data-bs-target="#privacyModal" (click)="openPrivacyModal()">Privacy policy</a>
          <!-- <span class="mx-2">·</span>
          <a href="#">Support</a> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Privacy Policy Modal -->
  <div *ngIf="showPrivacyPolicy" class="main-modal" id="privacyModal" aria-labelledby="privacyModalLabel" aria-hidden="true">
    <div class="modal-main-content rounded-4 p-4">
      <div class="modal-header">
        <h5 class="modal-title fw-bold me-auto" id="privacyModalLabel">Privacy Policy</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePrivacyModal()"></button>
      </div>

      <div class="modal-body pt-3 justify-text">
        <p>
          <strong>VisitorBridge</strong> is the brandname of Visitor Management Solution provided by <strong>DNV
            Security Solutions Pvt Ltd</strong>.
          DNV Security Solutions Pvt Ltd (referred to as “DNV”, “we”, “our”, or “us”) values the privacy of all users of
          the VisitorBridge platform —
          including host organizations, their employees, and visitors. This Privacy Policy outlines how we collect, use,
          and safeguard information based on user type.
        </p>
  
        <hr>
  
        <h6 class="fw-bold">1. Privacy Policy for Host Organizations and Their Employees</h6>
        <p>
          This section applies to organizations that use VisitorBridge to manage visitor entry and their assigned
          employees (Admins, Super Admins, Hosts).
        </p>
        <p class="fw-bold mb-1">Information We Collect:</p>
        <ul>
          <li>Organization Name</li>
          <li>Employee Names, Email IDs, Phone Numbers</li>
          <li>Role-based access information (e.g., Host, Admin)</li>
          <li>Audit trails and log activity</li>
          <li>Usage preferences and configuration settings</li>
        </ul>
        <p class="fw-bold mb-1">How We Use This Information:</p>
        <ul>
          <li>To create and manage organization accounts</li>
          <li>To assign appropriate user roles</li>
          <li>To facilitate visitor approval workflows</li>
          <li>To provide support and implementation services</li>
          <li>To monitor system usage and enhance security</li>
        </ul>
        <p class="fw-bold mb-1">Data Security & Access:</p>
        <ul>
          <li>Only authorized users from your organization can access your data</li>
          <li>DNV does not use host data for advertising or marketing</li>
          <li>Data access is role-based and logged for auditability</li>
        </ul>
        <p class="fw-bold mb-1">Data Storage:</p>
        <ul>
          <li>Hosted securely on cloud infrastructure within India or other compliant jurisdictions</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold">2. Privacy Policy for Visitors</h6>
        <p>This section applies to individuals who are visiting an organization using the VisitorBridge platform.</p>
        <p class="fw-bold mb-1">Information We Collect:</p>
        <ul>
          <li>Full Name</li>
          <li>Contact Number</li>
          <li>Email Address</li>
          <li>Government ID details (e.g., Aadhaar, PAN, Driving License)</li>
          <li>Host Name and Department</li>
          <li>Purpose and duration of visit</li>
          <li>Declaration consent (if required)</li>
          <li>Safety video acknowledgment (if required)</li>
        </ul>
        <p class="fw-bold mb-1">How We Use This Information:</p>
        <ul>
          <li>To authenticate and register your visit</li>
          <li>To notify your host</li>
          <li>To ensure security and compliance of the visited workplace</li>
          <li>To facilitate faster entry in future visits (if marked as favourite)</li>
        </ul>
        <p class="fw-bold mb-1">Data Handling:</p>
        <ul>
          <li>The information is collected on behalf of the host organization</li>
          <li>Data is only accessible to authorized users within that organization</li>
          <li>Visitor data is not shared with third parties for advertising or profiling</li>
        </ul>
        <p class="fw-bold mb-1">Data Retention & Security:</p>
        <ul>
          <li>Visitor data is encrypted in transit and at rest</li>
          <li>Access is restricted to approved roles (e.g., Admin, Super Admin)</li>
          <li>Blacklisted visitors will be flagged and blocked as per organization policy</li>
        </ul>
  
        <hr>
  
        <h6 class="fw-bold">3. General Terms for All Users</h6>
        <p class="fw-bold mb-1">Data Hosting & Transfers:</p>
        <ul>
          <li>Data is hosted on secure, third-party cloud infrastructure within India or other permitted regions</li>
        </ul>
        <p class="fw-bold mb-1">Policy Updates:</p>
        <ul>
          <li>This policy may be revised periodically. The updated version will be available on our website and app
            login page with the effective date.</li>
        </ul>
        <div class="text-center">
          <p class="fw-bold mb-1">Contact Us:</p>
          <ul>
            <li>Email: <a href="mailto:support&#64;visitorbridge.in">support&#64;visitorbridge.in</a></li>
            <li>Email: <a href="mailto:contact&#64;dnvsspl.com">contact&#64;dnvsspl.com</a></li>
          </ul>
        </div>       
      </div>
  
    </div>
  </div>

  <!-- Bottom Grid -->
  <div class="position-fixed bottom-0 w-100">
    <div class="row g-0">
      <div class="col-4 one-grid"></div>
      <div class="col-4 two-grid"></div>
      <div class="col-4 three-grid"></div>
    </div>
  </div>
</div>